
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';


export class Service extends BaseEntity {

  serviceCode     : string;
  person          : Person  = new Person();
  role            : Role    = new Role();

  periodActivDay  : Date;
  salesAmount     : number;

  constructor() {
    super();

  }
}